<template>
  <v-container grid-list-xl fluid>
    <FabricRangeSelector type="Panel Glide Blind" :value="selectedFabricGroup" v-on:selected-fabric-group="selectedFabricGroup = $event" :v="$v.selectedFabricGroup" :error="$v.selectedFabricGroup.$error"></FabricRangeSelector>

    <FabricSelector :fabricGroupID="selectedFabricGroup" :value="item.fabric" v-on:selected-fabric="selectedFabric = $event" :v="$v.item.fabric" :error="$v.item.fabric.$error"></FabricSelector>

    <ColorSelector :fabricID="selectedFabric" :value="item.color" v-on:selected-color="item.color = $event" :v="$v.item.color" :error="$v.item.color.$error"></ColorSelector>

    <DimensionSelector v-on:room="setRoom($event)" :valueName="item.name" :valueWidth="item.width" :valueDrop="item.drop" ref="dimensionSelector" @ready="isReady => readyToSubmitDimension = isReady" :type="this.item.type"></DimensionSelector>

    <CustomizationSelector title="Track Option" :value="item.variations.trackOption" :options="['Track 1 - 3 Track 3 Panel', 'Track 1 Reverse - 3 Track 3 Panel', 'Track 2 - 4 Track 4 Panel', 'Track 2 Reverse - 4 Track 4 Panel', 'Track 3 - 5 Track 5 Panel', 'Track 3 Reverse - 5 Track 5 Panel', 'Track 4 - 5 Track 6 Panel', 'Track 4 Reverse - 5 Track 6 Panel', 'Track 5 - 5 Track 9 Panel', 'Track 6 - 5 Track 9 Panel']" v-on:selected-option="item.variations.trackOption = $event" :v="$v.item.variations.trackOption" :error="$v.item.variations.trackOption.$error"></CustomizationSelector>

    <CustomizationSelector title="Track Colour" :value="item.variations.trackColor" :options="['Anodised Silver', 'White', 'Birch White', 'Black']" v-on:selected-option="item.variations.trackColor = $event" :v="$v.item.variations.trackColor" :error="$v.item.variations.trackColor.$error"></CustomizationSelector>

    <CustomizationSelector title="Base Rail Colour" :value="item.variations.baseRailColor" :options="['Anodised Silver', 'Dune', 'Bronze Pearl', 'Satin Black', 'White', 'Bone', 'Sandstone']" v-on:selected-option="item.variations.baseRailColor = $event" :v="$v.item.variations.baseRailColor" :error="$v.item.variations.baseRailColor.$error"></CustomizationSelector>

    <div v-if="incInstall">
      <v-checkbox label="Install?" color="primary" v-model="customInstall"></v-checkbox>
      <v-text-field v-if="customInstall" label="Install Price" v-model="item.installPrice"></v-text-field>
    </div>

    <!-- <v-checkbox label="Motorized?" color="primary" v-model="motorized"></v-checkbox>
    <v-select v-if="motorized" @change="motorActions" v-model="item.motor" :items="[{ text: 'SOMFY - Sonesse 30 Li-ion'},{ text: 'SOMFY - Altus 28 Li-ion'},{ text: 'SOMFY - Altus 40 RTS - wired'},{ text: 'SOMFY - Sonesse 40 30/30 - wired'},{ text: 'ACMEDA - AUTOMATE | Li-ion 1.1'}, { text: 'ACMEDA - AUTOMATE | Li-ion 3.0'}, { text: 'ACMEDA - AUTOMATE | E6 - wired'}]" label="Motor"></v-select>
    <v-text-field v-if="motorized" label="Motor Price" v-model="item.motorPrice" readonly></v-text-field> -->
    <v-textarea name="notes" label="Line Item Notes" v-model="item.notes"></v-textarea>
    <v-btn v-if="!edit" @click="addItem()" color="primary">Add {{ item.type }}</v-btn>
    <v-btn v-else @click="addItem()" color="primary">Update {{ item.type }}</v-btn>
    <b>${{ (item.total).toFixed(2) }}</b>
  </v-container>
</template>

<script>
import ItemService from '@/services/ItemService'

import FabricRangeSelector from '@/components/parts/FabricRangeSelector'
import FabricSelector from '@/components/parts/FabricSelector'
import ColorSelector from '@/components/parts/ColorSelector'
import DimensionSelector from '@/components/parts/DimensionSelector'
import CustomizationSelector from '@/components/parts/CustomizationSelector'
import { required } from 'vuelidate/lib/validators'

const gConfig = require('../../../gConfig.json')

export default {
  props: {
    edittingItem: {
      default: null
    },
    editChange: {
      default: null
    }
  },
  components: {
    FabricRangeSelector,
    FabricSelector,
    ColorSelector,
    DimensionSelector,
    CustomizationSelector
  },
  data () {
    return {
      selectedFabricGroup: null,
      selectedFabric: null,
      customInstall: false,
      motorized: false,
      readyToSubmitDimension: false,
      edit: false,
      item: {
        type: 'Panel Glide Blind',
        fabric: null,
        color: null,
        name: null,
        width: null,
        drop: null,
        total: 0,
        orderID: null,
        installPrice: 0,
        motor: null,
        motorPrice: 0,
        notes: null,
        variations: {
          trackOption: null,
          trackColor: null,
          baseRailColor: null
        }
      },
      incInstall: gConfig.install
    }
  },
  validations: {
    item: {
      fabric: { required },
      color: { required },
      name: { required },
      drop: { required },
      width: { required },
      variations: {
        trackOption: { required },
        trackColor: { required },
        baseRailColor: { required }
      }
    },
    selectedFabricGroup: { required }
  },
  mounted () {
    this.useEdittingItem(this.edittingItem)
  },
  watch: {
    item: {
      handler (item) {
        this.getPrice(item)
      },
      deep: true
    },
    selectedFabric (val) {
      this.item.fabric = val
    },
    motorized (val) {
      if (!val) {
        this.item.motor = null
        this.item.motorPrice = 0
      }
    },
    customInstall (val) {
      if (!val) {
        this.item.installPrice = 0
      }
    },
    edittingItem (item) {
      this.useEdittingItem(item)
    }
  },
  methods: {
    async getPrice (item) {
      const response = await ItemService.getPricing(item)
      if (response.data.price) {
        this.item.total = response.data.price
      }
    },

    setRoom (room) {
      this.item.width = room.width
      this.item.drop = room.drop
      this.item.name = room.name
    },

    addItem () {
      this.$refs.dimensionSelector.touch()
      this.$v.item.$touch()
      this.$v.selectedFabricGroup.$touch()
      if (this.$v.item.$pending || this.$v.item.$error || !this.readyToSubmitDimension || this.$v.selectedFabricGroup.$pending || this.$v.selectedFabricGroup.$error) return

      this.edit = false
      this.$emit('create-item', this.item)
    },

    async motorActions (value) {
      switch (value) {
        case 'SOMFY - Sonesse 30 Li-ion':
          this.item.motorPrice = 295
          break
        case 'SOMFY - Altus 28 Li-ion':
          this.item.motorPrice = 210
          break
        case 'SOMFY - Altus 40 RTS - wired':
          this.item.motorPrice = 265
          break
        case 'SOMFY - Sonesse 40 30/30 - wired':
          this.item.motorPrice = 380
          break
        case 'ACMEDA - AUTOMATE | Li-ion 1.1':
          this.item.motorPrice = 250
          break
        case 'ACMEDA - AUTOMATE | Li-ion 3.0':
          this.item.motorPrice = 350
          break
        case 'ACMEDA - AUTOMATE | E6 - wired':
          this.item.motorPrice = 199
          break
      }
    },

    useEdittingItem (item) {
      if (!this.editChange) {
        if (item) {
          this.edit = true
          this.item = item
          this.selectedFabricGroup = (item.fabric.group._id ? item.fabric.group._id : item.fabric.group)
          this.selectedFabric = (item.fabric._id ? item.fabric._id : item.fabric)
          this.item.color = (item.color._id ? item.color._id : item.color)
          this.motorized = parseInt(item.motorPrice) > 0
          this.customInstall = parseInt(item.installPrice) > 0
        }
      } else {
        this.item = {
          type: 'Panel Glide Blind',
          fabric: null,
          color: null,
          name: null,
          width: null,
          drop: null,
          total: 0,
          orderID: null,
          installPrice: 0,
          motor: null,
          motorPrice: 0,
          notes: null,
          variations: {
            trackOption: null,
            trackColor: null,
            baseRailColor: null
          }
        }
        this.item._id = item._id
        this.item.name = item.name
        this.item.width = item.width
        this.item.drop = item.drop
        this.item.orderID = item.orderID
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/products/PanelGlideBlind.vue